import {
  useLottiePlayer,
  useTranslation,
  useWithdrawForm,
} from '@starsoft/common/hooks';
import styles from './styles.module.scss';
import { useFormContext } from 'react-hook-form';
import { WithdrawFormCreateDto } from '@starsoft/common/dto/withdrawals/baseWithdrawalInputDto/withdraw-create-form.dto';

/**
 * TransactionsModalWithdrawContentFormLayoutNoMethodsAvailable Component
 * This component is responsible for displaying a message and animation when no withdrawal methods are available.
 *
 * @returns {JSX.Element} A container with a Lottie animation and a description message.
 *
 * @example
 * // Usage example:
 * <TransactionsModalWithdrawContentFormLayoutNoMethodsAvailable />
 */
export default function TransactionsModalWithdrawContentFormLayoutNoMethodsAvailable() {
  // Retrieve the translation function for the 'common' namespace
  const { t } = useTranslation('common');
  // Retrieve form context methods for watching and setting form values
  const { watch, setValue } = useFormContext<WithdrawFormCreateDto>();
  // Use custom hook to manage withdrawal form state and methods
  const {
    accountByCoinQuery: { currentAccount },
  } = useWithdrawForm(watch, setValue);

  // Use Lottie player hook to manage animation
  const { lottieAnimationRef } = useLottiePlayer({
    path: '/under-maintenence.json',
    dependecyArray: [currentAccount],
  });

  // Render the component with a Lottie animation and a description message
  return (
    <div className={styles.container}>
      <div className={styles.container__lottie} ref={lottieAnimationRef} />
      <div className={styles.container__description}>
        {t('withdraw_no_methods_available_description', {
          coin: currentAccount?.coin?.code,
        })}
      </div>
    </div>
  );
}
